import { Type } from 'class-transformer';

export class CurriculumSectionReplacedByModel {
	section_id: number;
	section_title: string;
}

export function CurriculumSectionReplacedByModel_ClassTransform_Type() {
	return CurriculumSectionReplacedByModel;
}

export class CurriculumSectionMappingReplacementModel {
	replaces: CurriculumSectionReplacedByModel[];
	@Type(CurriculumSectionReplacedByModel_ClassTransform_Type)
	replacedBy: CurriculumSectionReplacedByModel;
}

export function CurriculumSectionMappingReplacementModel_ClassTransform_Type() {
	return CurriculumSectionMappingReplacementModel;
}
